enum TerritoryLevel {
  ADM1 = "adm1", // state
  ADM2 = "adm2", // county
  ADM3 = "adm3", // postal code
}

export default TerritoryLevel;
